export const OMEGA_WS_PLAYER_INBOX_CHANNEL = import.meta.env.VITE_OMEGA_WS_PLAYER_INBOX_CHANNEL ?? '';
export const OMEGA_CHRONOS_API = import.meta.env.VITE_OMEGA_CHRONOS_API ?? '';